export default "__VITE_ASSET__LgTx1mBd__"